import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Breadcrumbs from '../navigation/Breadcrumbs';
import { buildServiceBreadcrumbs } from '../navigation/breadcrumbUtils';
import './ObjectDetection.css';

const ObjectDetection = () => {
  const location = useLocation();
  const servicesIndexView = location.state?.servicesIndexView;
  const backPath = servicesIndexView ? '/services' : '/';

  return (
    <div className="object-detection-page-wrapper">
      <div className="object-detection-page-container">
        <Breadcrumbs
          items={buildServiceBreadcrumbs('services', 'Object Detection')}
        />

        <div className="object-detection-back-link">
          <Link
            to={backPath}
            state={servicesIndexView ? { servicesIndexView } : undefined}
          >
            {servicesIndexView ? '\u2190 Back' : '\u2190 Back to Home'}
          </Link>
        </div>

        <div className="object-detection-page-hero">
          <h1>Object Detection Services</h1>
          <p>
            BlackRoth provides advanced Object Detection solutions powered by
            Artificial Intelligence and Computer Vision to identify, track,
            and analyze objects in images and video streams with high accuracy.
          </p>
        </div>

        <section className="object-detection-page-section">
          <h2>Overview</h2>
          <p>
            Object Detection is a critical component of modern AI systems,
            enabling machines to recognize and locate multiple objects within
            visual data. BlackRoth builds intelligent detection systems that
            operate in real time and at scale for enterprise use cases.
          </p>
        </section>

        <section className="object-detection-page-section">
          <h2>Core Capabilities</h2>
          <p>
            Our solutions are designed to handle complex environments,
            large-scale data, and real-world constraints while maintaining
            accuracy, performance, and reliability.
          </p>
        </section>

        <section className="object-detection-page-section">
          <h2>Services We Offer</h2>
          <ul className="object-detection-service-list">
            <li>Image & Video Object Detection</li>
            <li>Real-Time Object Tracking</li>
            <li>Custom AI Model Training</li>
            <li>Surveillance & Monitoring Solutions</li>
            <li>Industrial & Manufacturing Inspection</li>
            <li>Retail Analytics & Customer Insights</li>
            <li>Autonomous Systems & Smart Devices</li>
            <li>Model Optimization & Deployment</li>
          </ul>
        </section>

        <section className="object-detection-page-section">
          <h2>Industry Use Cases</h2>
          <p>
            Our Object Detection services are widely used across industries
            including security, retail, healthcare, manufacturing, logistics,
            and smart cities to automate processes and improve operational
            efficiency.
          </p>
        </section>

        <section className="object-detection-page-section">
          <h2>Technology Stack</h2>
          <p>
            We leverage modern AI frameworks and tools such as Python, OpenCV,
            TensorFlow, PyTorch, YOLO, cloud-based GPU processing, and scalable
            deployment pipelines to deliver robust detection systems.
          </p>
        </section>

        <section className="object-detection-page-section">
          <h2>Security & Reliability</h2>
          <p>
            BlackRoth ensures secure data handling, responsible AI practices,
            and compliance with enterprise standards, making our Object
            Detection solutions safe, reliable, and production-ready.
          </p>
        </section>
      </div>
    </div>
  );
};

export default ObjectDetection;

